import React from "react";
import Page from "../templates/support/childrin&education/childrin&education";
import { Helmet } from "react-helmet";

export default function home() {
  return (
    <div>
      <Helmet>
        <title>
          Education Programs for students | Community Development | Hirdaramani
        </title>
        <meta
          name="title"
          content="Education Programs for students | Community Development | Hirdaramani"
        />
        <meta
          name="description"
          content="Check out how our educational programs are conducting to support and to uplift the education of the children."
        />
        <link
          rel="canonical"
          href="https://sustainability.hirdaramani.com/support/children&education/"
        />
        <meta property="og:locale" content="en_US" />
        <meta name="keywords" content="Education Programs for students" />
        <meta
          property="og:title"
          content="Education Programs for students | Community Development | Hirdaramani"
        />
        <meta
          property="og:description"
          content="Check out how our educational programs are conducting to support and to uplift the education of the children."
        />
        <meta
          property="og:image"
          content="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo.png"
        />
        <meta
          property="og:url"
          content="https://sustainability.hirdaramani.com/support/children&education/"
        />
      </Helmet>

      <Page />
    </div>
  );
}
